import Switch from 'rc-switch';
import styled, { css } from 'styled-components';

import { toggleConsts } from './Toggle.consts';
import { ToggleLabelPosition, ToggleSize } from './Toggle.types';

type LabelProps = {
  size: ToggleSize;
  labelPosition: ToggleLabelPosition;
  disabled: boolean;
};

type ToggleProps = {
  size: ToggleSize;
};

const ToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Toggle: any = styled(Switch)<ToggleProps>`
  ${({ size, prefixCls, theme }) => {
    const { width, height, circle } = toggleConsts[size];

    return css`
      &.${prefixCls} {
        position: relative;
        display: block;
        width: ${width}px;
        height: ${height}px;
        padding: 0;
        border-radius: ${height / 2}px;
        border: 0;
        background-color: ${theme.border.medium};
        cursor: pointer;
        transition: background-color 0.3s ease-out;

        &:after {
          position: absolute;
          width: ${circle.size}px;
          height: ${circle.size}px;
          left: ${circle.offset}px;
          top: ${circle.offset}px;
          border-radius: ${circle.size / 2}px;
          background-color: ${theme.text.onSecondary.strong};
          content: '';
          cursor: pointer;
          transition: transform 0.3s ease-out;
        }

        &:hover {
          background-color: ${theme.focus.medium};
        }

        &:focus {
          box-shadow: 0 0 0 3px ${theme.focus.medium};
          outline: none;
        }

        &-checked {
          background-color: ${theme.focus.strong};

          &:after {
            transform: translateX(${circle.onPosition}px);
          }
        }

        &-disabled {
          cursor: no-drop;
          background: ${theme.border.subtle};

          &-checked {
            background-color: ${theme.focus.subtle};
          }
        }
      }
    `;
  }}
`;

const Label = styled.span<LabelProps>`
  ${({ disabled, labelPosition, size, theme }) => css`
    ${size === 'xsmall' && theme.label.extraSmall.bold};
    ${size === 'small' && theme.label.small.bold};
    ${size === 'medium' && theme.label.medium.bold};
    ${size === 'large' && theme.label.large.bold};
    color: ${disabled ? theme.text.onSurface.inactive : theme.text.onSurface.strong};
    margin: ${labelPosition === 'left' ? '0 10px 0 0' : '0 0 0 10px'};
  `}
`;

export { Toggle, Label, ToggleWrapper };
